import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import getters from './getters'
import mutationsFactory from './mutations'
import actionsFactory from './actions'

Vue.use(Vuex)

export default class StoreFactory {
  constructor(VUE) {
    const mutations = mutationsFactory(VUE)
    const actions = actionsFactory(VUE)
    const store = new Vuex.Store({
      state: {
        testApiMsg: 'default',
        initDataPending: true,
        exchangeRate: '27.15',
        menuMobile: false,
        searchMobile: false,
        filtersMobile: false,
        quickOrderModal: false,
        preOrderModal: false,
        productInfoModal: null,
        galleryModal: null,
        notifyStockModal: false,
        deliveryModal: false,
        headline: '',
        notice: '',
        notices: [],
        breadcrumbs: [], // { name_ru, name_ua, to }
        categories: [], // { name_ru, name_ua, slug, filters[slug], children[{...}] }
        filters: [], // [{ category: 'slug': attributes: [{ slug, name_ru, name_ua, options: [{ slug, name_ru, name_ua, value, options }, ...]}, ...], ... ]
        popularProducts: [],
        usedPhones: [],
        accessories: [],
        category: {
          currentPath: '',
          products: [], // current products list in the category scope
          viewMode: true, // true - tiles, false - list
          filters: {}, // current applied filters
          // deferredFilters: {},
          deferredFilters: false, // not reset filters after category change
          sort: '', // empty-string|price_asc|price_desc|sale
          page: 1,
          perPage: 12, // 12|24|36
          accessories: [],
          crossSale: [],
          warranty: [],
          meta: {},
          used_meta: {},
          used_text_block_ru: '',
          text_block_ru: '',
        },
        product: {
          currentPath: '',
          id: null,
          slug: '',
          name: '',
          stock: true,
          used: false,
          preorder: false,
          filters: {}, // { "filterSlug": "optionSlug", ... }
          status: 0, // float number
          img: [],
          imgf: [],
          imgsrc: [], // todo: responsive images for sliders
          imgsz: [],
          price: 0,
          priceUsd: 0,
          newPrice: 0,
          newPriceUsd: 0,
          kitDisc: 0,
          warranty: [],
          options: [], // links to other products in current category by some options (color, memory)
          bage: '', // sale | superPrice
          rating: 0,
          feedbacks: [],
          description: '',
          specs: '',
        },
        selectedFilters: {},
        productModal: {
          name: 'Undefined',
        },
        cart: {
          items: [], // { id, name, price, priceUsd, qty, warranty, link, kitDisc }
          qty: 0,
          price: 0,
          priceUsd: 0,
          addedNotice: false,
        },
        delivery: {
          method: null,
          city: '',
          cityId: '',
          department: '',
          departmentId: '',
          phone: '',
          userName: '',
          address: '',
          cityRefs: [],
          departmentRefs: [],
        },
        order: {},
        payment: {
          status: null,
        },
        appealResult: null,
        searchQuery: '',
        search: [],
        tradeIn: {},
        repair: {},
        franchise: {},
        blog: {
          posts: [],
        },
        slider: {
          slide: [],
        },
        lang: '',
        netpeakModal: false,
        subscribedUser: false,
        subscriptionSent: false,
      },
      getters,
      mutations,
      actions,
      plugins: [
        createPersistedState({
          paths: ['breadcrumbs', 'cart', 'category', 'delivery', 'payment'],
        }),
      ],
      submit: {},
      transfer: {},
      // modules: {}
    })
    StoreFactory.store = store
    return store
  }
}
